import { UpdatePasswordPayload } from '../../../../types/requests';
import { ConstructPost } from '../../../types/ConstructPost';
import { MIDDLE_OFFICE_BASE_PATH } from '../../constants/middleOfficeBasePath';

export const postUpdatePassword = (
  constructPost: ConstructPost,
  data: UpdatePasswordPayload,
): Promise<unknown> =>
  constructPost(
    `${MIDDLE_OFFICE_BASE_PATH}/users/password/update`,
    { data },
    { preventDefaultErrorToast: true },
  );
